import { memo } from "react";
import MuiTooltip from "@mui/material/Tooltip";

export default memo(
  MuiTooltip,
  (prevProps, nextProps) =>
    prevProps.title === nextProps.title &&
    prevProps.children === nextProps.children
);
